/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import o from "react";
import { ReorderRowIcon as n } from "../../components/icons/reorder-row-svg.mjs";
import { getRowReorderCellTdProps as c } from "./utils.mjs";
import { useRowReorderCellClientTdProps as d } from "./useRowReorderCellClientTdProps.mjs";
const i = (r) => {
  const { cellProps: e } = r, { tdProps: t } = c(e), l = d(e);
  return /* @__PURE__ */ o.createElement("td", { ...t, ...l, style: { touchAction: "none" } }, /* @__PURE__ */ o.createElement(n, null));
};
export {
  i as GridRowReorderCell
};
